import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FormGroup extends Component {
  render() {
    const {
      children,
      className,
      id,
      validation,
      validationProps: {
        className: validationClassName,
        ...validationProps
      } = {},
      ...otherProps
    } = this.props;

    const attributes = {
      ...otherProps,
      'aria-invalid': validation ? true : false,
      className: classNames('form-group', { 'has-error': validation }, className)
    };

    const validationAttributes = {
      ...validationProps,
      id: `${id}-help-block`,
      className: classNames('help-block', validationClassName)
    };

    return (
      <div {...attributes}>
        {children}
        {
          // Only show the help block if there really is a validation message
          validation && typeof validation === 'string' && false ?
            <span {...validationAttributes}>{validation}</span> :
            null
        }
      </div>
    );
  }
}

FormGroup.propTypes = {
  id: PropTypes.string,
  validation: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  validationProps: PropTypes.object
};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/containers/components/form-group.js